module.exports = __webpack_public_path__ + "assets/img/kv-8fc87764.jpg";